<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © WALIEX.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Digitaliza tu trabajo
                </div>
            </div>
        </div>
    </div>
</footer>